import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface SupervisorRouteProps {
    children: React.ReactNode;
}

const SupervisorRoute: React.FC<SupervisorRouteProps> = ({ children }) => {
    const { user } = useAuthStore();

    const isSupervisor = user?.role === 'supervisor' || user?.role === 'diretor' || user?.role === 'admin';

    if (!user || !isSupervisor) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default SupervisorRoute;
